import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { InputView } from '../Inputs/InputView';
import { SmallView } from '../Typography/SmallView';
export const ChoiceItemTextView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.choiceItemText,
    style(theme, mediaQuery, window, props) {
        return {
            container: Object.assign({ width: '100%' }, mediaQuery.md({
                width: undefined
            })),
            inputText: {
                fontSize: 16,
                lineHeight: 18
            }
        };
    }
})(({ id, testID, customize, min_value, style, value, onChange }) => {
    const verify = useCallback((text) => {
        const error = typeof min_value === 'number' && Number(text) < min_value
            ? (customize === null || customize === void 0 ? void 0 : customize.validation_error_message) || `Minimum value is ${min_value}`
            : undefined;
        return error || '';
    }, [value]);
    return (_jsx(InputView, { testID: `choice-item-${testID || (customize === null || customize === void 0 ? void 0 : customize.label) || (customize === null || customize === void 0 ? void 0 : customize.placeholder) || ''}`, underline: false, verify: verify, before: (customize === null || customize === void 0 ? void 0 : customize.prefix)
            ? () => (_jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.inputText, children: customize === null || customize === void 0 ? void 0 : customize.prefix }))
            : undefined, after: (customize === null || customize === void 0 ? void 0 : customize.suffix)
            ? () => (_jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.inputText, children: customize === null || customize === void 0 ? void 0 : customize.suffix }))
            : undefined, label: customize === null || customize === void 0 ? void 0 : customize.label, placeholder: customize === null || customize === void 0 ? void 0 : customize.placeholder, value: value, onChangeText: text => onChange === null || onChange === void 0 ? void 0 : onChange(id, text) }));
});
